export default "__VITE_ASSET__0fe8d016__"